import {
  defineComponent, computed,
} from 'vue';

import ProductCardPrice from '/src/vue/components/ProductCardPrice.ts';

export default defineComponent({
  delimiters: ['${', '}'],
  components: {
    ProductCardPrice,
  },
  props: {
    defaultSku: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    uri: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    images: {
      type: String,
      default: null,
    },
    thumbnail: {
      type: String,
      default: null,
    },
    loginUrl: {
      type: String,
      default: null,
    },
    isSos: {
      type: Boolean,
      default: false,
    },
    isOnSale: {
      type: Boolean,
      default: false,
    },
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(props: any) {
    const image = computed(() => {
      if (props.thumbnail) {
        return props.thumbnail;
      }
      if (!props.images) {
        return null;
      }
      const splitImages = props.images.split(',');
      if (splitImages.length) {
        return splitImages[0];
      }
      return null;
    });
    return {
      image,
    };
  },
  computed: {
    showIsOnSale() {
      return this.isCustomerWithSaleAccess && this.isOnSale;
    },
    isCustomerWithSaleAccess() {
      return this.$store.getters.statuses.isCustomerWithSaleAccess;
    },
  },
  template: '#t-product-card',
});
